import { createInstance } from '@/helpers/api/base'
import { AreaHistory } from '@/types/area'
import { useAppQuery } from '@/helpers/api/query'
import { formatInTimeZone } from 'date-fns-tz'
import { useDateStore } from '@/components/DateInput'

const AREAS_HISTORY_KEY = 'AREAS-HISTORY'

export const useGetAreasHistory = () => {
    const { date } = useDateStore()
    const formattedDate = formatInTimeZone(date, 'UTC', 'yyyy-MM-dd')

    return useAppQuery<AreaHistory[]>({
        queryKey: [AREAS_HISTORY_KEY, formattedDate],
        queryFn: () =>
            createInstance({
                url: '/hubs/areas/history',
                method: 'GET',
                params: {
                    Date: formattedDate,
                },
                paramsSerializer: {
                    indexes: null,
                },
            }),
        staleTime: Infinity,
    })
}
